var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEntriesCancelling(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.6693 7.00016C13.6693 10.6821 10.6845 13.6668 7.0026 13.6668C3.32071 13.6668 0.335938 10.6821 0.335938 7.00016C0.335938 3.31826 3.32071 0.333496 7.0026 0.333496C10.6845 0.333496 13.6693 3.31826 13.6693 7.00016ZM4.98236 4.97993C5.17762 4.78467 5.4942 4.78467 5.68946 4.97993L7.00258 6.29305L8.31569 4.97994C8.51095 4.78468 8.82753 4.78468 9.0228 4.97994C9.21806 5.17521 9.21806 5.49179 9.0228 5.68705L7.70969 7.00016L9.02278 8.31325C9.21804 8.50851 9.21804 8.82509 9.02278 9.02036C8.82752 9.21562 8.51094 9.21562 8.31568 9.02036L7.00258 7.70726L5.68948 9.02037C5.49422 9.21563 5.17763 9.21563 4.98237 9.02037C4.78711 8.82511 4.78711 8.50853 4.98237 8.31326L6.29548 7.00016L4.98236 5.68704C4.78709 5.49177 4.78709 5.17519 4.98236 4.97993Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEntriesCancelling);
export default __webpack_public_path__ + "static/media/entries-cancelling.da72e8a3f88f49a013f0cce49141add2.svg";
export { ForwardRef as ReactComponent };